'use client';

import Logo from '@/assets/logo/nec_logo.jpeg';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../container';
import { NavLinks } from './nav-links';

interface HeaderProps {
  isHomepage?: boolean;
}

export const Header: FC<HeaderProps> = () => {
  return (
    <header className="relative z-50 border-b border-[#e7edf6] bg-white">
      <nav aria-label="Main navigation">
        <Container className="flex h-[88px] items-center justify-between sm:h-[96px]">
          <Link to="/" aria-label="National Electoral Commission home" className="block">
            <span className="relative block h-12 w-[172px] overflow-hidden sm:w-[184px]">
              <img
                src={Logo}
                className="absolute left-1/2 top-1/2 w-[210px] max-w-none -translate-x-1/2 -translate-y-1/2 sm:w-[224px]"
                alt="National Electoral Commission"
              />
            </span>
          </Link>
          <div className="flex items-center gap-3 sm:gap-8">
            <NavLinks />
          </div>
        </Container>
      </nav>
    </header>
  );
};
